var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransition = function SvgTransition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.872 16.744h14.963v-1.237H4.872l3.933-3.934-.883-.884-5.436 5.436 5.436 5.436.883-.884zM18.951 7.993H3.546V6.756h15.405l-3.933-3.933.884-.884 5.436 5.436-5.436 5.436-.884-.884z"
  }))));
};
export default SvgTransition;